import { ApplicationBranding } from '@into-discovery/browsewebshared';
import colorStyles from '@/styles/utils/variables.module.scss';

export const appBranding: ApplicationBranding = {
  primaryColor: colorStyles.primary,
  primaryHoverColor: colorStyles.primaryHover,
  primaryActiveColor: colorStyles.primaryActive,
};
